export default function DeadStockReport() {
  return (
    <div className="erp-page-grid">
      <h2>Dead Stock Report</h2>
    </div>
  );
}